<iframe
    #embedIframe
  *ngIf="component.embed.src"
  [src]="component.embed.src | safe : 'resourceUrl'"
  style="width: 100%; height: 100%; border: none"
></iframe>
<span class="img-placeholder" *ngIf="!component.embed.src">
  <i class="bx bx-link-alt"></i>
</span>
